import { createContext } from 'react';

const ConnectContext = createContext({
  isInitialized: false,
  instanceAlias: ''
});

export default ConnectContext;
